import React, { useEffect, useState } from 'react'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  IconButton,
  TextField,
  FormHelperText,
  Autocomplete
} from '@mui/material'
import CustomTypography from '../../globalStyles/fonts'
import CloseIcon from '@mui/icons-material/Close'
import { toast } from 'react-toastify'
import { originZoneService } from '../../utils/services/originZoneService'

const ZoneModal = ({ open, handleClose, onAddData, selectedZone }) => {
  const [zoneDetails, setZoneDetails] = useState({
    name: '',
    code: '',
    zip: ''
  })
  const initialData = () => {
    setZoneDetails({
      name: '',
      code: '',
      zip: ''
    })
    setFormErrors({})
  }
  const [formErrors, setFormErrors] = useState({})

  const validateForm = () => {
    const errors = {}
    if (!zoneDetails.name) errors.name = 'Name is required.'
    if (!zoneDetails.code) errors.code = 'Code is required.'
    if (!zoneDetails.zip) errors.zip = 'Zip is required.'
    setFormErrors(errors)
    return Object.keys(errors).length === 0
  }

  useEffect(() => {
    if (selectedZone) {
      setZoneDetails({
        name: selectedZone?.name || '',
        code: selectedZone?.code || '',
        zip: selectedZone?.zip || ''
      })
    } else {
      initialData()
    }
  }, [selectedZone])
  const handleInputChange = (e) => {
    const { name, value } = e.target
    setZoneDetails((prevData) => ({
      ...prevData,
      [name]: value
    }))
  }

  const handleEditData = async (e) => {
    e.preventDefault()
    if (!validateForm()) return
    try {
      await originZoneService.edit(
        {
          name: zoneDetails.name,
          code: zoneDetails.code,
          zip: zoneDetails.zip
        },
        selectedZone._id
      )
      onAddData && onAddData()
      toast.success('Zone edited successfully!')
      initialData()
    } catch (e) {
      console.error(e)
    }
    initialData()
    handleClose()
  }

  const handleSave = async (e) => {
    e.preventDefault()
    if (!validateForm()) return
    try {
      await originZoneService.create({
        name: zoneDetails.name,
        code: zoneDetails.code,
        zip: zoneDetails.zip
      })
      onAddData && onAddData()
      toast.success('Zone created successfully!')
      initialData()
      handleClose()
    } catch (e) {
      toast.error('Failed to create Zone.')
      console.error(e)
    }
  }

  return (
    <Dialog
      open={open}
      onClose={() => {
        initialData()
        handleClose()
      }}
      maxWidth="md"
      aria-labelledby="form-dialog-title"
    >
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <DialogTitle
          id="form-dialog-title"
          style={{
            fontFamily: 'Poppins',
            fontSize: 24,
            fontWeight: 500,
            color: '#000000'
          }}
        >
          {selectedZone ? 'Edit Zone' : 'Create Zone'}
        </DialogTitle>
        <IconButton onClick={handleClose}>
          <CloseIcon />
        </IconButton>
      </div>
      <Divider style={{ marginBottom: 10 }} />
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12}>
            <CustomTypography>Name </CustomTypography>
            <TextField
              size="small"
              name="name"
              value={zoneDetails.name}
              onChange={handleInputChange}
              fullWidth
              margin="dense"
              error={!!formErrors.name}
              helperText={formErrors.name}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <CustomTypography>Code</CustomTypography>
            <TextField
              size="small"
              name="code"
              value={zoneDetails.code}
              onChange={handleInputChange}
              fullWidth
              margin="dense"
              error={!!formErrors.code}
              helperText={formErrors.code}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <CustomTypography>Zip</CustomTypography>
            <TextField
              size="small"
              name="zip"
              value={zoneDetails.zip}
              onChange={handleInputChange}
              fullWidth
              margin="dense"
              error={!!formErrors.zip}
              helperText={formErrors.zip}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions style={{ paddingBottom: 15, paddingRight: 15 }}>
        <Button
          onClick={() => {
            handleClose()
            initialData()
          }}
          variant="outlined"
          style={{
            fontFamily: 'Poppins',
            fontSize: 14,
            fontWeight: 600
          }}
        >
          Cancel
        </Button>
        <Button
          onClick={(e) => (selectedZone ? handleEditData(e) : handleSave(e))}
          variant="contained"
          style={{
            fontFamily: 'Poppins',
            fontSize: 14,
            fontWeight: 600
          }}
        >
          {selectedZone ? 'Save' : 'Add'}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ZoneModal
